import type { IconProps } from '../types/IconProps.ts';
export const Key: IconProps = {
    name: 'Key',
    children: [
        `<circle cx="7.5" cy="15.5" r="5.5" />`,
        `<path d="M11.5 11.5 20 2M18.64 4.1l2.18 1.84a1 1 0 0 1 .08 1.45l-2.27 2.44a1 1 0 0 1-1.35.1l-1.99-1.55" />`,
    ]
};